<template>
  <div>
    <v-row>
      <v-col sm="6">
        <v-text-field
          :label="$t('locations.ref')"
          v-model="overview.code"
        ></v-text-field>
      </v-col>
      <v-col sm="6">
        <v-text-field
          :label="$t('locations.name') + ' *'"
          v-model="overview.name"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <!-- TODO: remove -->
      <!-- <v-flex sm6>
        <v-text-field
          :label="$t('locations.company') + ' *'"
          :disabled="companyFilled"
          v-model="overview.company"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-flex> -->

      <v-col sm="6">
        <v-select
          :items="equipmentTypes"
          attach
          chips
          :label="$t('locations.equipment')"
          multiple
          v-model="overview.equipment"
          color="kazan"
        ></v-select>
      </v-col>
      <v-col sm="6">
        <v-select
          :items="accessibilityTypes"
          attach
          chips
          :label="$t('locations.accessibility')"
          multiple
          v-model="overview.accessibility"
          color="kazan"
        ></v-select>
      </v-col>
      <v-col sm="6">
        <v-select
          :items="locationTypes"
          attach
          :label="$t('locations.type') + ' *'"
          v-model="overview.type"
          :rules="[v => !!v || $t('general.required_field')]"
          ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'LocationFormOverview',
  props: ['value', 'companyFilled'],
  data () {
    return {
      equipmentTypes: [
        this.$i18n.t('locations.hydraulic_ramp'),
        this.$i18n.t('locations.forklift'),
        this.$i18n.t('locations.pallet_truck'),
        this.$i18n.t('locations.loadingbay')
      ],
      locationTypes: [
        this.$i18n.t('locations.warehouse'),
        this.$i18n.t('locations.factory'),
        this.$i18n.t('locations.DC'),
        this.$i18n.t('locations.construction')
      ],
      accessibilityTypes: [
        'accessibility A',
        'accessibility B',
        'accessibility C'
      ],
      overview: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    overview: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
